import { render } from "./OfficePopover.vue?vue&type=template&id=ca150188&scoped=true"
import script from "./OfficePopover.vue?vue&type=script&lang=js"
export * from "./OfficePopover.vue?vue&type=script&lang=js"

import "./OfficePopover.vue?vue&type=style&index=0&id=ca150188&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca150188"]])

export default __exports__